export default __webpack_public_path__ + "static/media/Yellow0005.b6472a0f.png";